import { render, staticRenderFns } from "./SinglePostPage.vue?vue&type=template&id=28493e8e&scoped=true"
import script from "./SinglePostPage.vue?vue&type=script&lang=js"
export * from "./SinglePostPage.vue?vue&type=script&lang=js"
import style0 from "./SinglePostPage.vue?vue&type=style&index=0&id=28493e8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28493e8e",
  null
  
)

export default component.exports